export const Dates = ({card, datesBtnRef, handleOpenDates}) => {
    return (
        <>
            {
                Object.keys(card?.date || {}).length !== 0 && (
                    <div className="cardModal__datesBlock">
                        <div className="cardModal__datesTitle">
                            Dates
                        </div>

                        <button
                            ref={datesBtnRef}
                            className="cardModal__dateBtn"
                            onClick={handleOpenDates}
                            type="button"
                        >
                <span>
                    {card?.date.start_date} - {card?.date?.due_date}
                </span>

                            <span className="cardModal__dateArrow">
                    ˅
                </span>
                        </button>
                    </div>
                )
            }
        </>
    )
}